import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheck, FileSignature, Bell, ShieldCheck, ScrollText, BarChart3, Target } from 'lucide-react';
import DashboardLayout from '../components/DashboardLayout';

const TOOLS = [
  { id: 'record-review', name: 'Clinical Record Review (QAPI)', note: 'Chart audit: admission forms, nursing documentation, POC and orders compliance', href: '/dashboard/qapi', icon: ClipboardCheck },
  { id: 'oasis-sign', name: 'OASIS Sign Queue', note: 'OASIS-E2 assessments waiting for clinician review and signature', href: '/dashboard/forms/oasis-e2/sign-list', icon: FileSignature },
  { id: 'alerts', name: 'Alerts & Deadlines', note: 'Recert periods ending, missing notes and other items needing action', href: '/dashboard/alerts', icon: Bell },
  { id: 'signature-audit', name: 'Signature Audit Trail', note: 'Who signed what and when, for surveys and ADRs', href: '/dashboard/tools/signature-audit', icon: ShieldCheck },
  { id: 'audit-log', name: 'Audit Log', note: 'Access and change history of patient records', href: '/dashboard/admin/audit', icon: ScrollText },
  { id: 'reports', name: 'Reports', note: 'Census, visits and agency performance reports', href: '/dashboard/reports', icon: BarChart3 },
  { id: 'patient-chart', name: 'Therapy Goals & Charts', note: 'Open a patient chart to review goals, evaluations and documents', href: '/dashboard/patients/chart', icon: Target },
];

// Quality assurance hub: every QA tool of the agency in one place
export default function QACenterPage() {
  return (
    <DashboardLayout>
      <div className="max-w-6xl mx-auto p-4 md:p-6 space-y-5" data-testid="qa-center-page">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">QA Center</h1>
          <p className="text-sm text-gray-500">Quality assurance tools for chart audits, signatures, deadlines and compliance.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {TOOLS.map(({ id, name, note, href, icon: Icon }) => (
            <Link key={id} to={href} className="group bg-white border rounded-xl p-4 hover:border-[#1e40af] hover:shadow-md transition-[border-color,box-shadow]" data-testid={`qa-tool-${id}`}>
              <Icon className="w-6 h-6 text-[#1e40af] mb-2" />
              <p className="font-semibold text-gray-900 group-hover:text-[#1e40af]">{name}</p>
              <p className="text-xs text-gray-500 mt-1">{note}</p>
            </Link>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
